import { api, usd } from '../lib/api';
import { ErrorNote, useLoad } from './ui';

type Counts = { d1: number; d7: number; d30: number };
const when = (v: string | null) => (v ? new Date(v).toLocaleString() : 'never');

// Platform admin: how many clients, stores and people are using the POS. Demo stores are kept apart.
export function Usage() {
  const u = useLoad(() => api<any>('/api/admin/usage'), []);
  const d = u.data;
  const row = (label: string, c: Counts) => <tr><td>{label}</td><td className="n">{c.d1}</td><td className="n">{c.d7}</td><td className="n">{c.d30}</td></tr>;
  return (
    <div className="stack">
      <ErrorNote error={u.error} />
      {d && (
        <>
          <div className="stats">
            <div><div className="v">{d.totals.real.activeClients}</div><div className="l">Active clients</div><div className="faint">{d.totals.real.clients} in all</div></div>
            <div><div className="v">{d.totals.real.stores}</div><div className="l">Stores</div></div>
            <div><div className="v">{d.totals.real.users}</div><div className="l">Logins (people)</div></div>
            <div><div className="v">{d.totals.real.loginUsers.d7}</div><div className="l">Signed in, last 7 days</div></div>
            <div><div className="v">{d.totals.real.activeStores.d7}</div><div className="l">Stores selling, last 7 days</div></div>
          </div>
          <div className="panel"><div className="panel-head"><h2 className="grow">Real clients</h2><span className="faint">{d.loginTrackingSince ? `Sign-ins counted since ${when(d.loginTrackingSince)}` : 'No sign-ins recorded yet'}</span></div>
            <div className="table-wrap"><table className="grid">
              <thead><tr><th /><th className="n">Today</th><th className="n">7 days</th><th className="n">30 days</th></tr></thead>
              <tbody>
                {row('People who signed in', d.totals.real.loginUsers)}
                {row('Clients ringing sales', d.totals.real.activeClientsBySales)}
                {row('Stores ringing sales', d.totals.real.activeStores)}
                {row('Sales', d.totals.real.sales)}
              </tbody>
            </table></div>
          </div>
          <div className="panel"><div className="panel-head"><h2 className="grow">By client</h2></div>
            <div className="table-wrap"><table className="grid">
              <thead><tr><th>Client</th><th className="n">Stores</th><th className="n">Logins</th><th className="n">Signed in (7 d)</th><th className="n">Sales (7 d)</th><th className="n">Sold, 30 d</th><th>Last sale</th><th>Last sign-in</th></tr></thead>
              <tbody>{d.clients.map((c: any) => (
                <tr key={c.id} style={c.status !== 'active' ? { opacity: 0.55 } : undefined}>
                  <td>{c.name}{c.demo && <span className="chip">demo</span>}{c.status !== 'active' && <span className="chip bad">{c.status}</span>}</td>
                  <td className="n">{c.stores}</td><td className="n">{c.users}</td><td className="n">{c.loginUsers.d7}</td>
                  <td className="n">{c.sales.d7}</td><td className="n">{usd(c.salesCents30)}</td>
                  <td>{when(c.lastSaleAt)}</td><td>{when(c.lastLoginAt)}</td>
                </tr>))}</tbody>
            </table></div>
          </div>
        </>
      )}
    </div>
  );
}
